<template>
  <div class="closeButton" @click="setModalVisible()">
    <img src="@/assets/images/admin/Cancel.svg" width="25px" />
  </div>
</template>

<script>
export default {
  name: "closeButton",
  props: {
    setModalVisible: Function
  }
};
</script>

<style>
.closeButton {
  float: right;
  margin-top: -25px;
  margin-right: -25px;
  cursor: pointer;
}
</style>